import { styled } from '@linaria/react'
import React, { type ComponentProps, type FC, type ReactNode } from 'react'
import { NavLink } from 'react-router'

import { Tag } from './Tag'
import type { Typography } from './Typography'
import { colors } from '../styles/colors'

const ScrollContainer = styled.div`
  display: flex;
  gap: 4px;
  overflow-x: auto;
  padding: 4px 15px;
  margin: 0 -15px;
  scroll-behavior: smooth;

  /* Скрытие скроллбара для WebKit браузеров */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Скрытие скроллбара для Firefox */
  scrollbar-width: none;
  -ms-overflow-style: none;

  @media (max-width: 360px) {
    padding: 4px 16px;
    margin: 0 -16px;
  }

  @media (max-width: 340px) {
    padding: 4px 12px;
    margin: 0 -12px;
  }
`

const TagContainer = styled.div`
  flex-shrink: 0;
`

export const TagList: FC<{
  tags: {
    id: string
    to: string
    label: ReactNode
    typographyProps?: ComponentProps<typeof Typography>
  }[]
  activeTagId?: string
}> = ({ tags, activeTagId }) => {
  return (
    <ScrollContainer>
      {tags.map(tag => (
        <TagContainer key={tag.id}>
          <NavLink to={tag.to} replace prefetch="render">
            <Tag
              isActive={tag.id === activeTagId}
              label={tag.label}
              variant="default"
              typographyProps={{
                fontSize: 14,
                fontWeight: 700,
                color: tag.id === activeTagId ? colors.white : colors.secondary,
                ...(tag.typographyProps ?? {}),
              }}
            />
          </NavLink>
        </TagContainer>
      ))}
    </ScrollContainer>
  )
}
